const State = [
  {
    name: "Andhra Pradesh",
    id: 1,
    value: false,
    childs: [
      {
        name: "Palnadu",
        id: 11111111,
        value: false,
      },
      {
        name: "Visakhapatnam",
        id: 1,
        value: false,
      },
      {
        name: "Vijayawada",
        id: 2,
        value: false,
      },
      {
        name: "Guntur",
        id: 3,
        value: false,
      },
      {
        name: "Nellore",
        id: 4,
        value: false,
      },
      {
        name: "Kurnool",
        id: 5,
        value: false,
      },
      {
        name: "Kakinada",
        id: 6,
        value: false,
      },
      {
        name: "Rajahmundry",
        id: 7,
        value: false,
      },
      {
        name: "Kadapa",
        id: 8,
        value: false,
      },
      {
        name: "Tirupati",
        id: 9,
        value: false,
      },
      {
        name: "Ananthapuram",
        id: 10,
        value: false,
      },
      {
        name: "Vizianagaram",
        id: 11,
        value: false,
      },
      {
        name: "Eluru",
        id: 12,
        value: false,
      },
      {
        name: "Nandyal",
        id: 13,
        value: false,
      },
      {
        name: "Ongole",
        id: 14,
        value: false,
      },
      {
        name: "Adoni",
        id: 15,
        value: false,
      },
      {
        name: "Madanapalle",
        id: 16,
        value: false,
      },
      {
        name: "Machilipatnam",
        id: 17,
        value: false,
      },
      {
        name: "Tenali",
        id: 18,
        value: false,
      },
      {
        name: "Proddatur",
        id: 19,
        value: false,
      },
      {
        name: "Chittor",
        id: 20,
        value: false,
      },
      {
        name: "Hindupur",
        id: 21,
        value: false,
      },
      {
        name: "Srikakulam",
        id: 22,
        value: false,
      },
      {
        name: "Bhimavaram",
        id: 23,
        value: false,
      },
      {
        name: "Tadepalligudem",
        id: 24,
        value: false,
      },
      {
        name: "Guntakal",
        id: 25,
        value: false,
      },
      {
        name: "Dharmavaram",
        id: 26,
        value: false,
      },
      {
        name: "Gudivada",
        id: 27,
        value: false,
      },
      {
        name: "Narasaraopet",
        id: 28,
        value: false,
      },
      {
        name: "Kadiri",
        id: 29,
        value: false,
      },
      {
        name: "Tadipatri",
        id: 30,
        value: false,
      },
      {
        name: "Mangalagiri",
        id: 31,
        value: false,
      },
      {
        name: "Chilkaluripet",
        id: 32,
        value: false,
      },

    ],
  },

  {
    name: "Arunachal Pradesh",
    id: 2,
    value: false,
    childs: [
      {
        name: "Anjaw",
        id: 1,
        value: false,
      },
      {
        name: "Changlang",
        id: 2,
        value: false,
      },
      {
        name: "East Kameng",
        id: 3,
        value: false,
      },
      {
        name: "East Siang",
        id: 4,
        value: false,
      },
      {
        name: "Lohit",
        id: 5,
        value: false,
      },
      {
        name: "Lower Subansiri",
        id: 6,
        value: false,
      },
      {
        name: "Papum Pare",
        id: 7,
        value: false,
      },
      {
        name: "Tawang",
        id: 8,
        value: false,
      },
      {
        name: "Tirap",
        id: 9,
        value: false,
      },
      {
        name: " Lower Dibang Valley",
        id: 10,
        value: false,
      },
      {
        name: "Upper Siang",
        id: 11,
        value: false,
      },
      {
        name: "Upper Subansiri",
        id: 12,
        value: false,
      },
      {
        name: "West Kameng",
        id: 13,
        value: false,
      },
      {
        name: "West Siang",
        id: 14,
        value: false,
      },
      {
        name: "Upper Dibang Valley",
        id: 15,
        value: false,
      },
      {
        name: "Kurung Kumey",
        id: 16,
        value: false,
      },
    ],
  },

  {
    name: "Assam",
    id: 3,
    value: false,
    childs: [
      {
        name: "Barpeta",
        id: 1,
        value: false,
      },
      {
        name: "Bongaigaon",
        id: 2,
        value: false,
      },
      {
        name: "Cachar",
        id: 3,
        value: false,
      },
      {
        name: "Darrang",
        id: 4,
        value: false,
      },
      {
        name: "Dhemaji",
        id: 5,
        value: false,
      },
      {
        name: "Dhubri",
        id: 6,
        value: false,
      },
      {
        name: "Dibrugarh",
        id: 7,
        value: false,
      },
      {
        name: "Dima Hasao",
        id: 8,
        value: false,
      },
      {
        name: "Goalpara",
        id: 9,
        value: false,
      },
      {
        name: "Golaghat",
        id: 10,
        value: false,
      },
      {
        name: "Hailakandi",
        id: 11,
        value: false,
      },
      {
        name: "Jorhat",
        id: 12,
        value: false,
      },
      {
        name: "Karbi Anglong",
        id: 13,
        value: false,
      },
      {
        name: "Karimganj",
        id: 14,
        value: false,
      },
      {
        name: "Kokrajhar",
        id: 15,
        value: false,
      },
      {
        name: "Lakhimpur",
        id: 16,
        value: false,
      },
      {
        name: "Morigaon",
        id: 17,
        value: false,
      },
      {
        name: "Nagaon",
        id: 18,
        value: false,
      },
      {
        name: "Nalbari",
        id: 19,
        value: false,
      },
      {
        name: "Sivasagar",
        id: 20,
        value: false,
      },
      {
        name: "Sonitpur",
        id: 21,
        value: false,
      },
      {
        name: "Tinsukia",
        id: 22,
        value: false,
      },
    ],
  },

  {
    name: "Bihar",
    id: 4,
    value: false,
    childs: [
      {
        name: "Araria",
        id: 1,
        value: false,
      },
      {
        name: "Aurangabad",
        id: 2,
        value: false,
      },
      {
        name: "Banka",
        id: 3,
        value: false,
      },
      {
        name: "Begusarai",
        id: 4,
        value: false,
      },
      {
        name: "Bhagalpur",
        id: 5,
        value: false,
      },
      {
        name: "Bhojpur",
        id: 6,
        value: false,
      },
      {
        name: "Buxar",
        id: 7,
        value: false,
      },
      {
        name: "Darbhanga",
        id: 8,
        value: false,
      },
      {
        name: "Gaya",
        id: 9,
        value: false,
      },
      {
        name: "Gopalganj",
        id: 10,
        value: false,
      },
      {
        name: "Jamui",
        id: 11,
        value: false,
      },
      {
        name: "Jehanabad",
        id: 12,
        value: false,
      },
      {
        name: "Kaimur",
        id: 13,
        value: false,
      },
      {
        name: "Katihar",
        id: 14,
        value: false,
      },
      {
        name: "Khagaria",
        id: 15,
        value: false,
      },
      {
        name: "Kishanganj",
        id: 16,
        value: false,
      },
      {
        name: "Lakhisarai",
        id: 17,
        value: false,
      },
      {
        name: "Madhepura",
        id: 18,
        value: false,
      },
      {
        name: "Madhubani",
        id: 19,
        value: false,
      },
      {
        name: "Munger",
        id: 20,
        value: false,
      },
      {
        name: "Muzaffarpur",
        id: 21,
        value: false,
      },
      {
        name: "Nalanda",
        id: 22,
        value: false,
      },
      {
        name: "Nawada",
        id: 23,
        value: false,
      },
      {
        name: "Pashchim Champaran",
        id: 24,
        value: false,
      },
      {
        name: "Patna",
        id: 25,
        value: false,
      },
      {
        name: "Purbi Champaran",
        id: 26,
        value: false,
      },
      {
        name: "Purnia",
        id: 27,
        value: false,
      },
      {
        name: "Rohtas",
        id: 28,
        value: false,
      },
      {
        name: "Saharsa",
        id: 29,
        value: false,
      },
      {
        name: "Samastipur",
        id: 30,
        value: false,
      },
      {
        name: "Saran",
        id: 31,
        value: false,
      },
      {
        name: "Sitamarhi",
        id: 32,
        value: false,
      },
      {
        name: "Siwan",
        id: 33,
        value: false,
      },
      {
        name: "Supaul",
        id: 34,
        value: false,
      },
      {
        name: "Vaishali",
        id: 35,
        value: false,
      },
    ],
  },

  {
    name: "Chhattisgarh",
    id: 5,
    value: false,
    childs: [
      {
        name: "Bastar",
        id: 1,
        value: false,
      },
      {
        name: "Bijapur",
        id: 2,
        value: false,
      },
      {
        name: "Bilaspur",
        id: 3,
        value: false,
      },
      {
        name: "Dantewada",
        id: 4,
        value: false,
      },
      {
        name: "Dhamtari",
        id: 5,
        value: false,
      },
      {
        name: "Janjgir Champa",
        id: 6,
        value: false,
      },
      {
        name: "Jashpur",
        id: 7,
        value: false,
      },
      {
        name: "Kabirdham",
        id: 8,
        value: false,
      },
      {
        name: "Kanker",
        id: 9,
        value: false,
      },
      {
        name: "Korba",
        id: 10,
        value: false,
      },
      {
        name: "Korea",
        id: 11,
        value: false,
      },
      {
        name: "Mahasamund",
        id: 12,
        value: false,
      },
      {
        name: "Narayanpur",
        id: 13,
        value: false,
      },
      {
        name: "Raigarh",
        id: 14,
        value: false,
      },
      {
        name: "Raipur",
        id: 15,
        value: false,
      },
      {
        name: "Rajnandgaon",
        id: 16,
        value: false,
      },
      {
        name: "Surguja",
        id: 17,
        value: false,
      },
    ],
  },

  {
    name: "Goa",
    id: 6,
    value: false,
    childs: [
      {
        name: "Bicholim",
        id: 1,
        value: false,
      },
      {
        name: "Canacona",
        id: 2,
        value: false,
      },
      {
        name: "Cuncolim",
        id: 3,
        value: false,
      },
      {
        name: "Curchorem",
        id: 4,
        value: false,
      },
      {
        name: "Mapusa",
        id: 5,
        value: false,
      },
      {
        name: "Margao",
        id: 6,
        value: false,
      },
      {
        name: "Mormugao",
        id: 7,
        value: false,
      },
      {
        name: "Panajim",
        id: 8,
        value: false,
      },
      {
        name: "Pernem",
        id: 9,
        value: false,
      },
      {
        name: "Ponda",
        id: 10,
        value: false,
      },
      {
        name: "Quepem",
        id: 11,
        value: false,
      },
      {
        name: "Sanguem",
        id: 12,
        value: false,
      },
      {
        name: "Sanquelim",
        id: 13,
        value: false,
      },
      {
        name: "Valpoi",
        id: 14,
        value: false,
      },
      {
        name: "Margao UA",
        id: 15,
        value: false,
      },
      {
        name: "Mormugao UA",
        id: 16,
        value: false,
      },
      {
        name: "Panaji UACapital City",
        id: 17,
        value: false,
      },
    ],
  },

  {
    name: "Gujarat",
    id: 7,
    value: false,
    childs: [
      {
        name: "Ahmedabad",
        id: 1,
        value: false,
      },
      {
        name: "Amreli",
        id: 2,
        value: false,
      },
      {
        name: "Ankleshvar",
        id: 3,
        value: false,
      },
      {
        name: "Bharuch",
        id: 4,
        value: false,
      },
      {
        name: "Bhavnagar",
        id: 5,
        value: false,
      },
      {
        name: "Bhuj",
        id: 6,
        value: false,
      },
      {
        name: "Botad",
        id: 7,
        value: false,
      },
      {
        name: "Dahod",
        id: 8,
        value: false,
      },
      {
        name: "Gandhidham",
        id: 9,
        value: false,
      },
      {
        name: "Gandhinagar",
        id: 10,
        value: false,
      },
      {
        name: "Godhra",
        id: 11,
        value: false,
      },
      {
        name: "Gondal",
        id: 12,
        value: false,
      },
      {
        name: "Jamnagar",
        id: 13,
        value: false,
      },
      {
        name: "Jetpur",
        id: 14,
        value: false,
      },
      {
        name: "Junagadh",
        id: 15,
        value: false,
      },
      {
        name: "Kalol",
        id: 16,
        value: false,
      },
      {
        name: "Mehsana",
        id: 17,
        value: false,
      },
      {
        name: "Morbi",
        id: 18,
        value: false,
      },
      {
        name: "Nadiad",
        id: 19,
        value: false,
      },
      {
        name: "Navsari",
        id: 20,
        value: false,
      },
      {
        name: "Palanpur",
        id: 21,
        value: false,
      },
      {
        name: "Patan",
        id: 22,
        value: false,
      },
      {
        name: "Porbandar",
        id: 23,
        value: false,
      },
      {
        name: "Rajkot",
        id: 24,
        value: false,
      },
      {
        name: "Surat",
        id: 25,
        value: false,
      },
      {
        name: "Surendranagar",
        id: 26,
        value: false,
      },
      {
        name: "Vadodara",
        id: 27,
        value: false,
      },
      {
        name: "Valsad",
        id: 28,
        value: false,
      },
      {
        name: "Vapi",
        id: 29,
        value: false,
      },
      {
        name: "Veraval",
        id: 30,
        value: false,
      },
    ],
  },

  {
    name: "Haryana",
    id: 8,
    value: false,
    childs: [
      {
        name: "Ambala",
        id: 1,
        value: false,
      },
      {
        name: "Bhiwani",
        id: 2,
        value: false,
      },
      {
        name: "Faridabad",
        id: 3,
        value: false,
      },
      {
        name: "Fatehabad",
        id: 4,
        value: false,
      },
      {
        name: "Gurgaon",
        id: 5,
        value: false,
      },
      {
        name: "Hisar",
        id: 6,
        value: false,
      },
      {
        name: "Jhajjar",
        id: 7,
        value: false,
      },
      {
        name: "Jind",
        id: 8,
        value: false,
      },
      {
        name: "Kaithal",
        id: 9,
        value: false,
      },
      {
        name: "Karnal",
        id: 10,
        value: false,
      },
      {
        name: "Kurukshetra",
        id: 11,
        value: false,
      },
      {
        name: "Mahendragarh",
        id: 12,
        value: false,
      },
      {
        name: "Mewat",
        id: 13,
        value: false,
      },
      {
        name: "Palwal",
        id: 14,
        value: false,
      },
      {
        name: "Panchkula",
        id: 15,
        value: false,
      },
      {
        name: "Panipat",
        id: 16,
        value: false,
      },
      {
        name: "Rewari",
        id: 17,
        value: false,
      },
      {
        name: "Rohtak",
        id: 18,
        value: false,
      },
      {
        name: "Sirsa",
        id: 19,
        value: false,
      },
      {
        name: "Sonipat",
        id: 20,
        value: false,
      },
      {
        name: "Yamuna Nagar",
        id: 21,
        value: false,
      },
    ],
  },

  {
    name: "Himachal Pradesh",
    id: 9,
    value: false,
    childs: [
      {
        name: "Bilaspur",
        id: 1,
        value: false,
      },
      {
        name: "Chamba",
        id: 2,
        value: false,
      },
      {
        name: "Hamirpur",
        id: 3,
        value: false,
      },
      {
        name: "Kangra",
        id: 4,
        value: false,
      },
      {
        name: "Kinnaur",
        id: 5,
        value: false,
      },
      {
        name: "Kullu",
        id: 6,
        value: false,
      },
      {
        name: "Lahaul and Spiti",
        id: 7,
        value: false,
      },
      {
        name: "Mandi",
        id: 8,
        value: false,
      },
      {
        name: "Shimla",
        id: 9,
        value: false,
      },
      {
        name: "Sirmaur",
        id: 10,
        value: false,
      },
      {
        name: "Solan",
        id: 11,
        value: false,
      },
      {
        name: "Una",
        id: 12,
        value: false,
      },
    ],
  },

  {
    name: "Jharkhand",
    id: 10,
    value: false,
    childs: [
      {
        name: "Bokaro Steel City",
        id: 1,
        value: false,
      },
      {
        name: "Chirkunda",
        id: 2,
        value: false,
      },
      {
        name: "Deoghar",
        id: 3,
        value: false,
      },
      {
        name: "Dhanbad",
        id: 4,
        value: false,
      },
      {
        name: "Giridih",
        id: 5,
        value: false,
      },
      {
        name: "Hazaribagh",
        id: 6,
        value: false,
      },
      {
        name: "Jamshedpur",
        id: 7,
        value: false,
      },
      {
        name: "Medininagar",
        id: 8,
        value: false,
      },
      {
        name: "Phusro",
        id: 9,
        value: false,
      },
      {
        name: "Ramgarh",
        id: 10,
        value: false,
      },
      {
        name: "Ranchi",
        id: 11,
        value: false,
      },
    ],
  },

  {
    name: "Karnataka",
    id: 11,
    value: false,
    childs: [
      {
        name: "Bagalkot",
        id: 1,
        value: false,
      },
      {
        name: "Belagavi",
        id: 2,
        value: false,
      },
      {
        name: "Bellary",
        id: 3,
        value: false,
      },
      {
        name: "Bengaluru Rural",
        id: 4,
        value: false,
      },
      {
        name: "Bengaluru Urban",
        id: 5,
        value: false,
      },
      {
        name: "Bidar",
        id: 6,
        value: false,
      },
      {
        name: "Chamarajanagar",
        id: 7,
        value: false,
      },
      {
        name: "Chikballapur",
        id: 8,
        value: false,
      },
      {
        name: "Chikkamagaluru",
        id: 9,
        value: false,
      },
      {
        name: "Chitradurga",
        id: 10,
        value: false,
      },
      {
        name: "Dakshina Kannada",
        id: 11,
        value: false,
      },
      {
        name: "Davanagere",
        id: 12,
        value: false,
      },
      {
        name: "Dharwad",
        id: 13,
        value: false,
      },
      {
        name: "Gadag",
        id: 14,
        value: false,
      },
      {
        name: "Hassan",
        id: 15,
        value: false,
      },
      {
        name: "Haveri",
        id: 16,
        value: false,
      },
      {
        name: "Kalaburagi",
        id: 17,
        value: false,
      },
      {
        name: "Kodagu",
        id: 18,
        value: false,
      },
      {
        name: "Kolar",
        id: 19,
        value: false,
      },
      {
        name: "Koppal",
        id: 20,
        value: false,
      },
      {
        name: "Mandya",
        id: 21,
        value: false,
      },
      {
        name: "Mysuru",
        id: 22,
        value: false,
      },
      {
        name: "Raichur",
        id: 23,
        value: false,
      },
      {
        name: "Ramanagara",
        id: 24,
        value: false,
      },
      {
        name: "Shivamogga",
        id: 25,
        value: false,
      },
      {
        name: "Tumakuru",
        id: 26,
        value: false,
      },
      {
        name: "Udupi",
        id: 27,
        value: false,
      },
      {
        name: "Uttara Kannada",
        id: 28,
        value: false,
      },
      {
        name: "Vijayapura",
        id: 29,
        value: false,
      },
      {
        name: "Yadgir",
        id: 30,
        value: false,
      },
    ],
  },

  {
    name: "Kerala",
    id: 12,
    value: false,
    childs: [
      {
        name: "Alappuzha",
        id: 1,
        value: false,
      },
      {
        name: "Beypore",
        id: 2,
        value: false,
      },
      {
        name: "Kanhangad",
        id: 3,
        value: false,
      },
      {
        name: "Kannur",
        id: 4,
        value: false,
      },
      {
        name: "Kasaragod",
        id: 5,
        value: false,
      },
      {
        name: "Kayamkulam",
        id: 6,
        value: false,
      },
      {
        name: "Kochi",
        id: 7,
        value: false,
      },
      {
        name: "Kollam",
        id: 8,
        value: false,
      },
      {
        name: "Kottayam",
        id: 9,
        value: false,
      },
      {
        name: "Koyilandy",
        id: 10,
        value: false,
      },
      {
        name: "Kozhikode",
        id: 11,
        value: false,
      },
      {
        name: "Kunnamkulam",
        id: 12,
        value: false,
      },
      {
        name: "Malappuram",
        id: 13,
        value: false,
      },
      {
        name: "Manjeri",
        id: 14,
        value: false,
      },
      {
        name: "Neyyattinkara",
        id: 15,
        value: false,
      },
      {
        name: "Nileshwaram",
        id: 16,
        value: false,
      },
      {
        name: "Palakkad",
        id: 17,
        value: false,
      },
      {
        name: "Payyanur",
        id: 18,
        value: false,
      },
      {
        name: "Ponnani",
        id: 19,
        value: false,
      },
      {
        name: "Taliparamba",
        id: 20,
        value: false,
      },
      {
        name: "Thalassery",
        id: 21,
        value: false,
      },
      {
        name: "Thiruvananthapuram",
        id: 22,
        value: false,
      },
      {
        name: "Thrissur",
        id: 23,
        value: false,
      },
      {
        name: "Tirur",
        id: 24,
        value: false,
      },
      {
        name: "Vadakara",
        id: 25,
        value: false,
      },
    ],
  },

  {
    name: "Madhya Pradesh",
    id: 13,
    value: false,
    childs: [
      {
        name: "Bhind",
        id: 1,
        value: false,
      },
      {
        name: "Bhopal",
        id: 2,
        value: false,
      },
      {
        name: "Burhanpur",
        id: 3,
        value: false,
      },
      {
        name: "Chhatarpur",
        id: 4,
        value: false,
      },
      {
        name: "Chhindwara",
        id: 5,
        value: false,
      },
      {
        name: "Damoh",
        id: 6,
        value: false,
      },
      {
        name: "Dewas",
        id: 7,
        value: false,
      },
      {
        name: "Guna",
        id: 8,
        value: false,
      },
      {
        name: "Gwalior",
        id: 9,
        value: false,
      },
      {
        name: "Indore",
        id: 10,
        value: false,
      },
      {
        name: "Jabalpur",
        id: 11,
        value: false,
      },
      {
        name: "Khandwa",
        id: 12,
        value: false,
      },
      {
        name: "Khargone",
        id: 13,
        value: false,
      },
      {
        name: "Mandsaur",
        id: 14,
        value: false,
      },
      {
        name: "Morena",
        id: 15,
        value: false,
      },
      {
        name: "Murwara",
        id: 16,
        value: false,
      },
      {
        name: "Neemuch",
        id: 17,
        value: false,
      },
      {
        name: "Ratlam",
        id: 18,
        value: false,
      },
      {
        name: "Rewa",
        id: 19,
        value: false,
      },
      {
        name: "Sagar",
        id: 20,
        value: false,
      },
      {
        name: "Satna",
        id: 21,
        value: false,
      },
      {
        name: "Shivpuri",
        id: 22,
        value: false,
      },
      {
        name: "Singrauli",
        id: 23,
        value: false,
      },
      {
        name: "Ujjain",
        id: 24,
        value: false,
      },
      {
        name: "Vidisha",
        id: 25,
        value: false,
      },
      {
        name: "Khahuraho",
        id: 26,
        value: false,
      },
    ],
  },

  {
    name: "Maharashtra",
    id: 14,
    value: false,
    childs: [
      {
        name: "Ahmadnagar",
        id: 1,
        value: false,
      },
      {
        name: "Akola",
        id: 2,
        value: false,
      },
      {
        name: "Amravati",
        id: 3,
        value: false,
      },
      {
        name: "Aurangabad",
        id: 4,
        value: false,
      },
      {
        name: "Bhiwandi",
        id: 5,
        value: false,
      },
      {
        name: "Bhusawal",
        id: 6,
        value: false,
      },
      {
        name: "Chandrapur",
        id: 7,
        value: false,
      },
      {
        name: "Dhule",
        id: 8,
        value: false,
      },
      {
        name: "Ichalkaranji",
        id: 9,
        value: false,
      },
      {
        name: "Jalgaon",
        id: 10,
        value: false,
      },
      {
        name: "Jalna",
        id: 11,
        value: false,
      },
      {
        name: "Kolhapur",
        id: 12,
        value: false,
      },
      {
        name: "Latur",
        id: 13,
        value: false,
      },
      {
        name: "Malegaon",
        id: 14,
        value: false,
      },
      {
        name: "Mumbai",
        id: 15,
        value: false,
      },
      {
        name: "Nagpur",
        id: 16,
        value: false,
      },
      {
        name: "Nanded",
        id: 17,
        value: false,
      },
      {
        name: "Nashik",
        id: 18,
        value: false,
      },
      {
        name: "Navi Mumbai",
        id: 19,
        value: false,
      },
      {
        name: "Panvel",
        id: 20,
        value: false,
      },
      {
        name: "Parbhani",
        id: 21,
        value: false,
      },
      {
        name: "Pune",
        id: 22,
        value: false,
      },
      {
        name: "Sangli",
        id: 23,
        value: false,
      },
      {
        name: "Solapur",
        id: 24,
        value: false,
      },
      {
        name: "Vasai-Virar",
        id: 25,
        value: false,
      },
    ],
  },

  {
    name: "Manipur",
    id: 15,
    value: false,
    childs: [
      {
        name: "Bishnupur",
        id: 1,
        value: false,
      },
      {
        name: "Chandel",
        id: 2,
        value: false,
      },
      {
        name: "Churachandpur",
        id: 3,
        value: false,
      },
      {
        name: "Imphal East",
        id: 4,
        value: false,
      },
      {
        name: "Imphal West",
        id: 5,
        value: false,
      },
      {
        name: "Senapati",
        id: 6,
        value: false,
      },
      {
        name: "Tamenglong",
        id: 7,
        value: false,
      },
      {
        name: "Thoubal",
        id: 8,
        value: false,
      },
      {
        name: "Ukhrul",
        id: 9,
        value: false,
      },
    ],
  },

  {
    name: "Meghalaya",
    id: 16,
    value: false,
    childs: [
      {
        name: "East Khasi Hills",
        id: 1,
        value: false,
      },
      {
        name: "West Garo Hills",
        id: 2,
        value: false,
      },
      {
        name: "Jaintia Hills",
        id: 3,
        value: false,
      },
      {
        name: "West Khasi Hills",
        id: 4,
        value: false,
      },
      {
        name: "East Garo Hills",
        id: 5,
        value: false,
      },
      {
        name: "Ri Bhoi",
        id: 6,
        value: false,
      },
      {
        name: "South Garo Hills",
        id: 7,
        value: false,
      },
    ],
  },

  {
    name: "Mizoram",
    id: 17,
    value: false,
    childs: [
      {
        name: "Aizawl",
        id: 1,
        value: false,
      },
      {
        name: "Champhai",
        id: 2,
        value: false,
      },
      {
        name: "Kolasib",
        id: 3,
        value: false,
      },
      {
        name: "Lawngtlai",
        id: 4,
        value: false,
      },
      {
        name: "Lunglei",
        id: 5,
        value: false,
      },
      {
        name: "Mamit",
        id: 6,
        value: false,
      },
      {
        name: "Saiha",
        id: 7,
        value: false,
      },
      {
        name: "Serchhip",
        id: 8,
        value: false,
      },
    ],
  },
  {
    name: "Nagaland",
    id: 18,
    value: false,
    childs: [
      {
        name: "Dimapur",
        id: 1,
        value: false,
      },
      {
        name: "Kiphire",
        id: 2,
        value: false,
      },
      {
        name: "Kohima",
        id: 3,
        value: false,
      },
      {
        name: "Longleng",
        id: 4,
        value: false,
      },
      {
        name: "Mokokchung",
        id: 5,
        value: false,
      },
      {
        name: "Peren",
        id: 6,
        value: false,
      },
      {
        name: "Phek",
        id: 7,
        value: false,
      },
      {
        name: "Soma",
        id: 8,
        value: false,
      },
      {
        name: "Tuensang",
        id: 9,
        value: false,
      },
      {
        name: "Wokha",
        id: 10,
        value: false,
      },
      {
        name: "Zunheboto",
        id: 11,
        value: false,
      },
    ],
  },

  {
    name: "Odisha",
    id: 19,
    value: false,
    childs: [
      {
        name: "Anugul",
        id: 1,
        value: false,
      },
      {
        name: "Balangir",
        id: 2,
        value: false,
      },
      {
        name: "Baleshwar",
        id: 3,
        value: false,
      },
      {
        name: "Bargarh",
        id: 4,
        value: false,
      },
      {
        name: "Bhadrak",
        id: 5,
        value: false,
      },
      {
        name: "Cuttack",
        id: 6,
        value: false,
      },
      {
        name: "Dhenkanal",
        id: 7,
        value: false,
      },
      {
        name: "Ganjam",
        id: 8,
        value: false,
      },
      {
        name: "Jagatsinghapur",
        id: 9,
        value: false,
      },
      {
        name: "Jajpur",
        id: 10,
        value: false,
      },
      {
        name: "Kalahandi",
        id: 11,
        value: false,
      },
      {
        name: "Kendrapara",
        id: 12,
        value: false,
      },
      {
        name: "Kendujhar",
        id: 13,
        value: false,
      },
      {
        name: "Khordha",
        id: 14,
        value: false,
      },
      {
        name: "Koraput",
        id: 15,
        value: false,
      },
      {
        name: "Mayurbhanj",
        id: 16,
        value: false,
      },
      {
        name: "Nabarangapur",
        id: 17,
        value: false,
      },
      {
        name: "Nayagarh",
        id: 18,
        value: false,
      },
      {
        name: "Puri",
        id: 19,
        value: false,
      },
      {
        name: "Rayagada",
        id: 20,
        value: false,
      },
      {
        name: "Sambalpur",
        id: 21,
        value: false,
      },
      {
        name: "Sundargarh",
        id: 22,
        value: false,
      },
    ],
  },

  {
    name: "Punjab",
    id: 20,
    value: false,
    childs: [
      {
        name: "Abohar",
        id: 1,
        value: false,
      },
      {
        name: "Amritsar",
        id: 2,
        value: false,
      },
      {
        name: "Barnala",
        id: 3,
        value: false,
      },
      {
        name: "Batala",
        id: 4,
        value: false,
      },
      {
        name: "Bathinda",
        id: 5,
        value: false,
      },
      {
        name: "Firozpur",
        id: 6,
        value: false,
      },
      {
        name: "Hoshiarpur",
        id: 7,
        value: false,
      },
      {
        name: "Jalandhar",
        id: 8,
        value: false,
      },
      {
        name: "Kapurthala",
        id: 9,
        value: false,
      },
      {
        name: "Khanna",
        id: 10,
        value: false,
      },
      {
        name: "Ludhiana",
        id: 11,
        value: false,
      },
      {
        name: "Malerkotla",
        id: 12,
        value: false,
      },
      {
        name: "Moga",
        id: 13,
        value: false,
      },
      {
        name: "Muktasar",
        id: 14,
        value: false,
      },
      {
        name: "Pathankot",
        id: 15,
        value: false,
      },
      {
        name: "Patiala",
        id: 16,
        value: false,
      },
      {
        name: "Phagwara",
        id: 17,
        value: false,
      },
      {
        name: "Rajpura",
        id: 18,
        value: false,
      },
      {
        name: "Sangrur",
        id: 19,
        value: false,
      },
    ],
  },

  {
    name: "Rajasthan",
    id: 21,
    value: false,
    childs: [
      {
        name: "Ajmer",
        id: 1,
        value: false,
      },
      {
        name: "Alwar",
        id: 2,
        value: false,
      },
      {
        name: "Banswara",
        id: 3,
        value: false,
      },
      {
        name: "Baran",
        id: 4,
        value: false,
      },
      {
        name: "Barmer",
        id: 5,
        value: false,
      },
      {
        name: "Bharatpur",
        id: 6,
        value: false,
      },
      {
        name: "Bhilwara",
        id: 7,
        value: false,
      },
      {
        name: "Bikaner",
        id: 8,
        value: false,
      },
      {
        name: "Bundi",
        id: 9,
        value: false,
      },
      {
        name: "Chittorgarh",
        id: 10,
        value: false,
      },
      {
        name: "Churu",
        id: 11,
        value: false,
      },
      {
        name: "Dausa",
        id: 12,
        value: false,
      },
      {
        name: "Dholpur",
        id: 13,
        value: false,
      },
      {
        name: "Dungarpur",
        id: 14,
        value: false,
      },
      {
        name: "Hanumangarh",
        id: 15,
        value: false,
      },
      {
        name: "Jaipur",
        id: 16,
        value: false,
      },
      {
        name: "Jaisalmer",
        id: 17,
        value: false,
      },
      {
        name: "Jalor",
        id: 18,
        value: false,
      },
      {
        name: "Jhalawar",
        id: 19,
        value: false,
      },
      {
        name: "Jhunjhunu",
        id: 20,
        value: false,
      },
      {
        name: "Jodhpur",
        id: 21,
        value: false,
      },
      {
        name: "Karauli",
        id: 22,
        value: false,
      },
      {
        name: "Kota",
        id: 23,
        value: false,
      },
      {
        name: "Nagaur",
        id: 24,
        value: false,
      },
      {
        name: "Pali",
        id: 25,
        value: false,
      },
      {
        name: "Pratapgarh",
        id: 26,
        value: false,
      },
      {
        name: "Rajsamand",
        id: 27,
        value: false,
      },
      {
        name: "Sawai Madhopur",
        id: 28,
        value: false,
      },
      {
        name: "Sikar",
        id: 29,
        value: false,
      },
      {
        name: "Sirohi",
        id: 30,
        value: false,
      },
      {
        name: "Sri Ganganagar",
        id: 31,
        value: false,
      },
      {
        name: "Tonk",
        id: 32,
        value: false,
      },
      {
        name: "Udaipur",
        id: 33,
        value: false,
      },
    ],
  },

  {
    name: "Sikkim",
    id: 22,
    value: false,
    childs: [
      {
        name: "East Sikkim",
        id: 1,
        value: false,
      },
      {
        name: "North Sikkim",
        id: 2,
        value: false,
      },
      {
        name: "South Sikkim",
        id: 3,
        value: false,
      },
      {
        name: "West Sikkim",
        id: 4,
        value: false,
      },
    ],
  },

  {
    name: "Tamilnadu",
    id: 23,
    value: false,
    childs: [
      {
        name: "Chennai",
        id: 1,
        value: false,
      },
      {
        name: "Kanchipuram",
        id: 2,
        value: false,
      },
      {
        name: "Vellore",
        id: 3,
        value: false,
      },
      {
        name: "Thiruvallur",
        id: 4,
        value: false,
      },
      {
        name: "Salem",
        id: 5,
        value: false,
      },
      {
        name: "Viluppuram",
        id: 6,
        value: false,
      },
      {
        name: "Coimbatore",
        id: 7,
        value: false,
      },
      {
        name: "Tirunelveli",
        id: 8,
        value: false,
      },
      {
        name: "Madurai",
        id: 9,
        value: false,
      },
      {
        name: "Tiruchirappalli",
        id: 10,
        value: false,
      },
      {
        name: "Cuddalore",
        id: 11,
        value: false,
      },
      {
        name: "Tiruppur",
        id: 12,
        value: false,
      },
      {
        name: "Tiruvannamalai",
        id: 13,
        value: false,
      },
      {
        name: "Thanjavur",
        id: 14,
        value: false,
      },
      {
        name: "Erode",
        id: 15,
        value: false,
      },
      {
        name: "Dindigul",
        id: 16,
        value: false,
      },
      {
        name: "Virudhunagar",
        id: 17,
        value: false,
      },
      {
        name: "Krishnagiri",
        id: 18,
        value: false,
      },
      {
        name: "Kanniyakumari",
        id: 19,
        value: false,
      },
      {
        name: "Thoothukkudi",
        id: 20,
        value: false,
      },
      {
        name: "Namakkal",
        id: 21,
        value: false,
      },
      {
        name: "Pudukkottai",
        id: 22,
        value: false,
      },
      {
        name: "Nagapattinam",
        id: 23,
        value: false,
      },
      {
        name: "Dharmapuri",
        id: 24,
        value: false,
      },
      {
        name: "Ramanathapuram",
        id: 25,
        value: false,
      },
      {
        name: "Sivaganga",
        id: 26,
        value: false,
      },
      {
        name: "Thiruvarur",
        id: 27,
        value: false,
      },
      {
        name: "Theni",
        id: 28,
        value: false,
      },
      {
        name: "Karur",
        id: 29,
        value: false,
      },
      {
        name: "Ariyalur",
        id: 30,
        value: false,
      },
      {
        name: "The Nilgiris",
        id: 31,
        value: false,
      },
      {
        name: "Perambalur",
        id: 32,
        value: false,
      },
    ],
  },

  {
    name: "Telangana",
    id: 24,
    value: false,
    childs: [
      {
        name: "Adilabad",
        id: 1,
        value: false,
      },
      {
        name: "Hyderabad ",
        id: 2,
        value: false,
      },
      {
        name: "Jagtial",
        id: 3,
        value: false,
      },
      {
        name: "Karimnagar",
        id: 4,
        value: false,
      },
      {
        name: "Khammam",
        id: 5,
        value: false,
      },
      {
        name: "Mahbubnagar",
        id: 6,
        value: false,
      },
      {
        name: "Miryalaguda",
        id: 7,
        value: false,
      },
      {
        name: "Nalgonda",
        id: 8,
        value: false,
      },
      {
        name: "Nizamabad",
        id: 9,
        value: false,
      },
      {
        name: "Ramagundam",
        id: 10,
        value: false,
      },
      {
        name: "Suryapet",
        id: 11,
        value: false,
      },
      {
        name: "Warangal",
        id: 12,
        value: false,
      },
    ],
  },

  {
    name: "Tripura",
    id: 25,
    value: false,
    childs: [
      {
        name: "North Tripura",
        id: 1,
        value: false,
      },
      {
        name: "Sephijala",
        id: 2,
        value: false,
      },
      {
        name: "South Tripura",
        id: 3,
        value: false,
      },
      {
        name: "West Tripura",
        id: 4,
        value: false,
      },
    ],
  },

  {
    name: "Uttar Pradesh",
    id: 26,
    value: false,
    childs: [
      {
        name: "Agra",
        id: 1,
        value: false,
      },
      {
        name: "Aligarh",
        id: 2,
        value: false,
      },
      {
        name: "Allahabad",
        id: 3,
        value: false,
      },
      {
        name: "Ambedkar Nagar",
        id: 4,
        value: false,
      },
      {
        name: "Amroha",
        id: 5,
        value: false,
      },
      {
        name: "Auraiya",
        id: 6,
        value: false,
      },
      {
        name: "Azamgarh",
        id: 7,
        value: false,
      },
      {
        name: "Badaun",
        id: 8,
        value: false,
      },
      {
        name: "Bahraich",
        id: 9,
        value: false,
      },
      {
        name: "Ballia",
        id: 10,
        value: false,
      },
      {
        name: "Balrampur",
        id: 11,
        value: false,
      },
      {
        name: "Banda",
        id: 12,
        value: false,
      },
      {
        name: "Barabanki",
        id: 13,
        value: false,
      },
      {
        name: "Bareilly",
        id: 14,
        value: false,
      },
      {
        name: "Basti",
        id: 15,
        value: false,
      },
      {
        name: "Bijnor",
        id: 16,
        value: false,
      },
      {
        name: "Bulandshahr",
        id: 17,
        value: false,
      },
      {
        name: "Chandauli",
        id: 18,
        value: false,
      },
      {
        name: "Deoria",
        id: 19,
        value: false,
      },
      {
        name: "Etah",
        id: 20,
        value: false,
      },
      {
        name: "Etawah",
        id: 21,
        value: false,
      },
      {
        name: "Faizabad",
        id: 22,
        value: false,
      },
      {
        name: "Farrukhabad",
        id: 23,
        value: false,
      },
      {
        name: "Fatehpur",
        id: 24,
        value: false,
      },
      {
        name: "Firozabad",
        id: 25,
        value: false,
      },
      {
        name: "Gautam Buddha Nagar",
        id: 26,
        value: false,
      },
      {
        name: "Ghaziabad",
        id: 27,
        value: false,
      },
      {
        name: "Ghazipur",
        id: 28,
        value: false,
      },
      {
        name: "Gonda",
        id: 29,
        value: false,
      },
      {
        name: "Gorkakhpur",
        id: 30,
        value: false,
      },
      {
        name: "Hamirpur",
        id: 31,
        value: false,
      },
      {
        name: "Hardoi",
        id: 32,
        value: false,
      },
      {
        name: "Hathras",
        id: 33,
        value: false,
      },
      {
        name: "Jaunpur",
        id: 34,
        value: false,
      },
      {
        name: "Jhansi",
        id: 35,
        value: false,
      },
      {
        name: "Kannauj",
        id: 36,
        value: false,
      },
      {
        name: "Kanpur Dehat",
        id: 37,
        value: false,
      },
      {
        name: "Kanpur Nagar",
        id: 38,
        value: false,
      },
      {
        name: "Kaushambi",
        id: 39,
        value: false,
      },
      {
        name: "Kushinagar",
        id: 40,
        value: false,
      },
      {
        name: "Lakhimpur Kheri",
        id: 41,
        value: false,
      },
      {
        name: "Lucknow",
        id: 42,
        value: false,
      },
      {
        name: "Maharajganj",
        id: 43,
        value: false,
      },
      {
        name: "Mainpuri",
        id: 44,
        value: false,
      },
      {
        name: "Mathura",
        id: 45,
        value: false,
      },
      {
        name: "Meerut",
        id: 46,
        value: false,
      },
      {
        name: "Mirzapur",
        id: 47,
        value: false,
      },
      {
        name: "Moradabad",
        id: 48,
        value: false,
      },
      {
        name: "Muzaffarnagar",
        id: 49,
        value: false,
      },
      {
        name: "Pilibhit",
        id: 50,
        value: false,
      },
      {
        name: "Pratapgarh",
        id: 51,
        value: false,
      },
      {
        name: "Rae Bareli",
        id: 52,
        value: false,
      },
      {
        name: "Rampur",
        id: 53,
        value: false,
      },
      {
        name: "Saharanpur",
        id: 54,
        value: false,
      },
      {
        name: "Shahjahanpur",
        id: 55,
        value: false,
      },
      {
        name: "Shamli",
        id: 56,
        value: false,
      },
      {
        name: "Siddharthnagar",
        id: 57,
        value: false,
      },
      {
        name: "Sitapur",
        id: 58,
        value: false,
      },
      {
        name: "Sonbhadra",
        id: 59,
        value: false,
      },
      {
        name: "Sultanpur",
        id: 60,
        value: false,
      },
      {
        name: "Unnao",
        id: 61,
        value: false,
      },
      {
        name: "Varanasi",
        id: 62,
        value: false,
      },
      {
        name: "Ayodhya",
        id: 63,
        value: false,
      },
    ],
  },

  {
    name: "Uttarakhand",
    id: 27,
    value: false,
    childs: [
      {
        name: "Almora",
        id: 1,
        value: false,
      },
      {
        name: "Chamoli",
        id: 2,
        value: false,
      },
      {
        name: "Dehradun",
        id: 3,
        value: false,
      },
      {
        name: "Haridwar",
        id: 4,
        value: false,
      },
      {
        name: "Nainital",
        id: 5,
        value: false,
      },
      {
        name: "Pauri Garhwal",
        id: 6,
        value: false,
      },
      {
        name: "Pithoragarh",
        id: 7,
        value: false,
      },
      {
        name: "Tehri Garhwal",
        id: 8,
        value: false,
      },
      {
        name: "Udham Singh Nagar",
        id: 9,
        value: false,
      },
      {
        name: "Uttarkashi",
        id: 10,
        value: false,
      },
    ],
  },

  {
    name: "West Bengal",
    id: 28,
    value: false,
    childs: [
      {
        name: "Asansol",
        id: 1,
        value: false,
      },
      {
        name: "Baharampur",
        id: 2,
        value: false,
      },
      {
        name: "Bardhaman",
        id: 3,
        value: false,
      },
      {
        name: "Dankuni",
        id: 4,
        value: false,
      },
      {
        name: "Dhulian",
        id: 5,
        value: false,
      },
      {
        name: "Durgapur",
        id: 6,
        value: false,
      },
      {
        name: "English Bazar",
        id: 7,
        value: false,
      },
      {
        name: "Habra",
        id: 8,
        value: false,
      },
      {
        name: "Haldia",
        id: 9,
        value: false,
      },
      {
        name: "Jalpaiguri",
        id: 10,
        value: false,
      },
      {
        name: "Kharagpur",
        id: 11,
        value: false,
      },
      {
        name: "Kolkata",
        id: 12,
        value: false,
      },
      {
        name: "Ranaghat",
        id: 13,
        value: false,
      },
      {
        name: "Shantipur",
        id: 14,
        value: false,
      },
      {
        name: "Siliguri",
        id: 15,
        value: false,
      },
    ],
  },
];

export default State;
